(function() {
  var parts = [
    '/cdn/shop/t/8/assets/revista-black-p1.txt',
    '/cdn/shop/t/8/assets/revista-black-p2.txt',
    '/cdn/shop/t/8/assets/revista-black-p3.txt',
    '/cdn/shop/t/8/assets/revista-black-p4.txt'
  ];
  Promise.all(parts.map(function(u) { return fetch(u).then(function(r) { return r.text(); }); }))
    .then(function(chunks) {
      var b64 = chunks.join('');
      var binary = atob(b64);
      var len = binary.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) { bytes[i] = binary.charCodeAt(i); }
      var blob = new Blob([bytes], { type: 'font/otf' });
      var url = URL.createObjectURL(blob);
      var font = new FontFace('Revista Black', 'url(' + url + ')', { weight: '900', style: 'normal' });
      font.load().then(function(loaded) {
        document.fonts.add(loaded);
        document.documentElement.classList.add('revista-loaded');
      }).catch(function(e) { console.error('Revista Black font failed to load', e); });
    })
    .catch(function(e) { console.error('Revista Black font parts failed to fetch', e); });
})();
